import { AbstractControl, FormArray, FormControl, FormGroup } from '@angular/forms';

export default class Utils {
  static getBaseUri() {
    let baseURI = document.baseURI;

    if (!baseURI) {
      const baseTags = document.getElementsByTagName('base');
      baseURI = baseTags.length ? baseTags[0].href : document.URL;
    }
    if (!baseURI.match('/$')) {
      baseURI = `${document.baseURI}/`;
    }

    return baseURI;

    //  const  = document.baseURI.endsWith('/') ? document.baseURI : `${document.baseURI}/`;

    }
    public static TestIsUndefined(value: any) {
        return typeof value === 'undefined';
        // return value === undefined;
  }
  /**
 * Deep clones the given AbstractControl, preserving values, validators, async validators, and disabled status.
 * @param control AbstractControl
 * @returns AbstractControl
 */
   public static cloneAbstractControl<T extends AbstractControl>(control: T): T {
    let newControl: T;

    if (control instanceof FormGroup) {
      const formGroup = new FormGroup({}, control.validator, control.asyncValidator);
      const controls = control.controls;

      Object.keys(controls).forEach(key => {
        formGroup.addControl(key, this.cloneAbstractControl(controls[key]));
      });

      newControl = formGroup as any;
    } else if (control instanceof FormArray) {
      const formArray = new FormArray([], control.validator, control.asyncValidator);

      control.controls.forEach(formControl => formArray.push(this.cloneAbstractControl(formControl)));

      newControl = formArray as any;
    } else if (control instanceof FormControl) {
      newControl = new FormControl(control.value, control.validator, control.asyncValidator) as any;
    } else {
      throw new Error('Error: unexpected control value');
    }

    if (control.disabled) {
      newControl.disable({ emitEvent: false });
    }

    return newControl;
  }

  /**
   * Creates a brand new object, free of reference to the original object
   * @param  {T} value
   * use newObject = this.util.deepCopy(originalObject);
   */
  public static deepCopy<T>(value: T): any {

    if (typeof value !== 'object' || value === null) {
      return value;
    }
    if (Array.isArray(value)) {
      return this.deepArray(value);
    }
    return this.deepObject(value);
  }

  public static deepObject<T>(source: T) {

    const result = {};

    Object.keys(source).forEach((key) => {

      const value = source[key];
      result[key] = this.deepCopy(value);
    }, {});
    return result as T;
  }

  public static deepArray<T extends any[]>(collection: T) {
    return collection.map((value) => {
      return this.deepCopy(value);
    });
  }

}
